import sidebar_var from './sidebar';

export const sidebar = sidebar_var;
export const header = { height: '62px' };

export default { sidebar, header };